module.exports = __webpack_public_path__ + "img/img19.c29b989b.jpg";